import React, { useContext, ReactNode } from 'react'
import styled, { ThemeContext } from 'styled-components'

type Color = 'pink' | 'white'

const Container = styled.button<{
  backgroundColor: string
  borderColor: string
  color: Color
  fontColor: string
  shadowColor?: string
}>`
  align-items: center;
  background: ${({ backgroundColor }) => backgroundColor};
  border: 1px solid ${({ borderColor }) => borderColor};
  border-radius: 35px;
  box-shadow: 0px 2px 4px ${({ backgroundColor, shadowColor }) => shadowColor || backgroundColor};
  box-sizing: border-box;
  color: ${({ fontColor }) => fontColor};
  display: flex;
  font-size: 14px;
  font-weight: ${({ color }) => (color === 'pink' ? 800 : 600)};
  justify-content: center;
  line-height: 1.7em;
  padding: 10px 0;
  text-align: center;
  width: 100%;
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    line-height: 1.5em;
    padding: 9px 0;
  }
`

type Props = {
  children: ReactNode
  className?: string
  color: Color
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}

type Palette = {
  [key in Color]: {
    background: string
    border: string
    font: string
    shadow: string
  }
}

export default function Button({ children, className, color, onClick }: Props) {
  const theme = useContext(ThemeContext)
  const palette: Palette = {
    pink: {
      background: theme.palette.primary.main,
      border: theme.palette.primary.main,
      font: theme.palette.font.light,
      shadow: 'rgba(255, 74, 139, 0.25)'
    },
    white: {
      background: theme.palette.background.main,
      border: theme.palette.border.main,
      font: theme.palette.font.link,
      shadow: 'rgba(0, 0, 0, 0.15)'
    }
  }

  return (
    <Container
      backgroundColor={palette[color].background}
      borderColor={palette[color].border}
      className={className}
      color={color}
      fontColor={palette[color].font}
      onClick={onClick}
      shadowColor={palette[color].shadow}
    >
      {children}
    </Container>
  )
}
